import { OrderProduct } from '@/views/personal-center/order/model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CartState {
  selectedGoods: OrderProduct[];
}

const initialState: CartState = {
  selectedGoods: [],
};

const cartSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setSelectedGoods: (state, action: PayloadAction<OrderProduct[]>) => {
      console.log('set', action.payload);
      state.selectedGoods = action.payload;
    },
    clearSelectedGoods: (state) => {
      state.selectedGoods = [];
    },
  },
});

export const { setSelectedGoods, clearSelectedGoods } = cartSlice.actions;
export default cartSlice.reducer;
